module.exports = "<app-slider></app-slider>\n<app-header></app-header>\n<div class=\"container\">\n    <router-outlet></router-outlet>\n</div>\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main